import React from "react";
import { Box, Typography } from "@mui/material";

// System-message row (assignment/call/closechat/blockcontact/lifecycle-style
// events) — plain icon + text, no pill/border/background box (Rahim,
// 2026-08-24: "we are going to change it to something like this [screenshot]
// see the system message is simple text and icon we will be using our new
// icon"). Icon color stays muted/neutral (text.secondary) rather than
// status-colored, matching this session's "convey status via icon shape, not
// color" convention. `fontSize` kept from stagingmerge — the Shopify-event
// caller (ChatBody.jsx) passes it explicitly; `time` dropped, no caller uses it.
const ChatLog = ({ icon, message = "Assigned to Ahmed", fontSize }) => {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        my: 2,
      }}
    >
      <Box
        sx={(theme) => ({
          display: "flex",
          alignItems: "center",
          gap: 0.625,
          maxWidth: "80%",
          color: theme.palette.mode === "dark" ? theme.palette.grey[200] : theme.palette.grey[700],
        })}
      >
        {icon && (
          <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0, lineHeight: 0 }}>
            {icon}
          </Box>
        )}
        <Typography
          sx={{
            fontSize: "0.8125rem",
            fontWeight: 500,
            color: "inherit",
            textAlign: "center",
            ...(fontSize && { fontSize }),
          }}
        >
          {message}
        </Typography>
      </Box>
    </Box>
  );
};

export default ChatLog;
